import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitFx } from '../models/jg/jg-physical-insp-unit-fx.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitFxService extends RequestService<JgPhysicalInspUnitFx> {
  static PATH = '/jg/physicalInsp/unitFx';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgPhysicalInspUnitFxService.PATH, globalService.debugUrl);
  }
}
